import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  .ant-form-item {
    width: 100%;
  }

  .ant-form-item .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    background-color: ${({ theme }) => theme.colors.white} !important;
    cursor: pointer !important;
  }

  .ant-form-item .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }

  .ant-form-item .ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.black5};
`;
